<template>
    <div class="delete-podcast">
        <button class="link link--red" type="button" @click="showModal = true">
            <slot>Delete</slot>
        </button>
        <ConfirmModal
            v-if="showModal"
            name="podcast-delete"
            :title="$t('podcasts.delete.title')"
            :ok-label="$t('misc.delete')"
            @confirmed="deletePodcast"
            @canceled="showModal = false"
        >
            <template #content>
                <div>
                    <Spinner v-if="loading" />
                    <p>{{ $t('podcasts.del  ete.text') }} {{ podcast.name }}</p>
                    <TransitionExpand v-if="error">
                        <ErrorList :error="error" />
                    </TransitionExpand>
                </div>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';

export default {
    name: 'PodcastDeleteModal',
    components: {
        ErrorList,
        TransitionExpand,
        ConfirmModal,
    },
    props: {
        podcast: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            loading: false,
            error: null,
        };
    },
    methods: {
        async deletePodcast() {
            try {
                this.loading = true;

                await this.$http.delete(`/api/v1/podcast/podcasts/${this.podcast.id}`);

                this.loading = false;
                this.showModal = false;
                this.$emit('deleted', this.podcast);
            } catch (e) {
                this.loading = false;
            }
        },
    },
};
</script>
